(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const staticPdpLabels = {
    nl: { readMore: 'Lees meer', showLess: 'Minder tonen', close: 'Sluiten', previous: 'Vorige afbeelding', next: 'Volgende afbeelding', moreInfo: 'Productdetail' },
    en: { readMore: 'Read more', showLess: 'Show less', close: 'Close', previous: 'Previous image', next: 'Next image', moreInfo: 'Product detail' },
    de: { readMore: 'Mehr lesen', showLess: 'Weniger anzeigen', close: 'Schließen', previous: 'Vorheriges Bild', next: 'Nächstes Bild', moreInfo: 'Produktdetail' },
    fr: { readMore: 'Lire la suite', showLess: 'Afficher moins', close: 'Fermer', previous: 'Image précédente', next: 'Image suivante', moreInfo: 'Détail du produit' },
    es: { readMore: 'Leer más', showLess: 'Mostrar menos', close: 'Cerrar', previous: 'Imagen anterior', next: 'Imagen siguiente', moreInfo: 'Detalle del producto' },
    it: { readMore: 'Leggi di più', showLess: 'Mostra meno', close: 'Chiudi', previous: 'Immagine precedente', next: 'Immagine successiva', moreInfo: 'Dettaglio prodotto' }
  };

  function localizeStaticPdpLabels(root = document) {
    const locale = String(document.documentElement.lang || 'nl').toLowerCase().slice(0, 2);
    const copy = staticPdpLabels[locale] || staticPdpLabels.en;
    root.querySelectorAll('.wn-product-buybox__description-more-label--more').forEach((node) => { node.textContent = copy.readMore; });
    root.querySelectorAll('.wn-product-buybox__description-more-label--less').forEach((node) => { node.textContent = copy.showLess; });
    root.querySelectorAll('[data-wn-gallery-previous]').forEach((node) => { node.setAttribute('aria-label', copy.previous); });
    root.querySelectorAll('[data-wn-gallery-next]').forEach((node) => { node.setAttribute('aria-label', copy.next); });
    root.querySelectorAll('[data-wn-bubble-close]').forEach((node) => { node.setAttribute('aria-label', copy.close); });
    root.querySelectorAll('[data-wn-bubble-trigger]').forEach((node) => { node.setAttribute('aria-label', copy.moreInfo); });
  }

  class WnUniversalGallery {
    constructor(root) {
      this.root = root;
      this.form = root.closest('wn-product-form');
      this.track = root.querySelector('[data-wn-gallery-track]');
      this.slides = [...root.querySelectorAll('[data-gallery-index]')];
      this.thumbs = [...root.querySelectorAll('[data-gallery-target-index]')];
      this.bubbles = [...root.querySelectorAll('[data-wn-bubble]')];
      this.counter = root.querySelector('[data-wn-gallery-counter]');
      this.activeIndex = 0;
      this.scrollFrame = 0;
      this.drag = null;
      if (!this.track || !this.slides.length) return;

      this.slides.forEach((slide) => {
        slide.hidden = false;
        slide.setAttribute('aria-hidden', 'false');
      });

      root.querySelector('[data-wn-gallery-previous]')?.addEventListener('click', () => this.go(this.activeIndex - 1));
      root.querySelector('[data-wn-gallery-next]')?.addEventListener('click', () => this.go(this.activeIndex + 1));
      this.thumbs.forEach((thumb) => thumb.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.go(Number(thumb.dataset.galleryTargetIndex || 1) - 1);
      }));

      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.syncFromScroll());
      }, { passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.go(this.activeIndex - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); this.go(this.activeIndex + 1); }
      });
      this.track.addEventListener('pointerdown', (event) => this.onPointerDown(event));
      this.track.addEventListener('pointermove', (event) => this.onPointerMove(event));
      this.track.addEventListener('pointerup', (event) => this.onPointerUp(event));
      this.track.addEventListener('pointercancel', () => this.finishDrag());

      this.form?.addEventListener('wn:product:media-change-request', (event) => {
        const id = String(event.detail?.mediaId || '');
        const index = this.slides.findIndex((slide) => String(slide.dataset.mediaPanel || '') === id);
        if (index < 0) return;
        event.preventDefault();
        this.go(index);
      });
      this.form?.addEventListener('wn:product:variant-change', (event) => {
        const id = String(event.detail?.variant?.featured_media_id || '');
        if (!id) return;
        const index = this.slides.findIndex((slide) => String(slide.dataset.mediaPanel || '') === id);
        if (index >= 0) this.go(index);
      });

      this.root.addEventListener('click', (event) => this.onBubbleClick(event));
      document.addEventListener('click', (event) => {
        if (!event.target.closest('[data-wn-bubble]')) this.closeBubbles();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.closeBubbles();
      });

      this.sync(0);
    }

    go(index) {
      const next = Math.max(0, Math.min(this.slides.length - 1, index));
      const slide = this.slides[next];
      this.track.scrollTo({ left: slide.offsetLeft, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      this.sync(next);
    }

    syncFromScroll() {
      const center = this.track.scrollLeft + (this.track.clientWidth / 2);
      let closest = 0;
      let distance = Infinity;
      this.slides.forEach((slide, index) => {
        const slideCenter = slide.offsetLeft + (slide.offsetWidth / 2);
        const nextDistance = Math.abs(center - slideCenter);
        if (nextDistance < distance) { distance = nextDistance; closest = index; }
      });
      this.sync(closest);
    }

    sync(index) {
      this.activeIndex = index;
      this.slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
      this.thumbs.forEach((thumb) => {
        const selected = Number(thumb.dataset.galleryTargetIndex || 1) - 1 === index;
        thumb.classList.toggle('is-active', selected);
        thumb.setAttribute('aria-current', String(selected));
        if (selected) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      });
      this.bubbles.forEach((bubble) => {
        const show = Number(bubble.dataset.mediaNumber || 1) - 1 === index;
        bubble.classList.toggle('is-visible', show);
        if (!show) this.closeBubble(bubble);
      });
      if (this.counter) this.counter.textContent = `${index + 1} / ${this.slides.length}`;
    }

    onPointerDown(event) {
      if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button, a')) return;
      this.drag = { id: event.pointerId, startX: event.clientX, scrollLeft: this.track.scrollLeft, moved: false };
      this.track.setPointerCapture?.(event.pointerId);
      this.track.classList.add('is-dragging');
    }

    onPointerMove(event) {
      if (!this.drag || this.drag.id !== event.pointerId) return;
      const delta = event.clientX - this.drag.startX;
      if (Math.abs(delta) > 4) this.drag.moved = true;
      this.track.scrollLeft = this.drag.scrollLeft - delta;
    }

    onPointerUp(event) {
      if (!this.drag || this.drag.id !== event.pointerId) return;
      const moved = this.drag.moved;
      this.finishDrag();
      if (moved) this.go(this.activeIndex);
    }

    finishDrag() {
      this.drag = null;
      this.track.classList.remove('is-dragging');
    }

    onBubbleClick(event) {
      const trigger = event.target.closest('[data-wn-bubble-trigger]');
      const close = event.target.closest('[data-wn-bubble-close]');
      if (!trigger && !close) return;
      event.preventDefault();
      event.stopPropagation();
      const bubble = event.target.closest('[data-wn-bubble]');
      if (!bubble) return;
      if (close) { this.closeBubble(bubble); return; }
      const isOpen = bubble.classList.contains('is-open');
      this.closeBubbles();
      if (!isOpen) {
        bubble.classList.add('is-open');
        bubble.querySelector('[data-wn-bubble-trigger]')?.setAttribute('aria-expanded', 'true');
        const panel = bubble.querySelector('[data-wn-bubble-panel]');
        if (panel) panel.hidden = false;
      }
    }

    closeBubble(bubble) {
      bubble.classList.remove('is-open');
      bubble.querySelector('[data-wn-bubble-trigger]')?.setAttribute('aria-expanded', 'false');
      const panel = bubble.querySelector('[data-wn-bubble-panel]');
      if (panel) panel.hidden = true;
    }

    closeBubbles() { this.bubbles.forEach((bubble) => this.closeBubble(bubble)); }
  }

  function selectRecommendation(button) {
    const form = button.closest('wn-product-form');
    if (!form) return;
    const values = [button.dataset.optionOne, button.dataset.optionTwo, button.dataset.optionThree].filter(Boolean);
    values.forEach((value) => {
      const option = [...form.querySelectorAll('[data-option-value]')].find((candidate) => candidate.dataset.optionValue === value);
      option?.click();
    });
    const details = button.closest('details');
    if (details) details.open = false;
    form.querySelector('[data-product-options]')?.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });
  }

  function boot(root = document) {
    localizeStaticPdpLabels(root);
    root.querySelectorAll('[data-wn-gallery]').forEach((gallery) => {
      if (gallery.dataset.wnReady === 'true') return;
      gallery.dataset.wnReady = 'true';
      new WnUniversalGallery(gallery);
    });
  }

  document.addEventListener('click', (event) => {
    const recommendation = event.target.closest('[data-wn-recommendation]');
    if (recommendation) { event.preventDefault(); selectRecommendation(recommendation); }
  });
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
})();
